import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  Legend,
} from "recharts";
import { Box, Typography } from "@mui/material";

const data = [
  { name: "Dark Knight", avgWatchTime: 120 },
  { name: "Mission Impossible", avgWatchTime: 95 },
  { name: "Iron Man", avgWatchTime: 65 },
  { name: "Minority Report", avgWatchTime: 99 },
];

const CustomTooltip = ({ active, payload, label }) => {
  if (active && payload && payload.length) {
    return (
      <Box
        sx={{
          backgroundColor: "#ffffff",
          border: "1px solid #ccc",
          padding: "10px",
        }}
      >
        <Typography variant="body2">{`Movie: ${label}`}</Typography>
        <Typography variant="body2" color="textSecondary">
          {`Average Watch Time: ${payload[0].value} minutes`}
        </Typography>
      </Box>
    );
  }

  return null;
};

const AverageWatchTimeChart = () => {
  return (
    <Box
      sx={{
        border: "1px solid lightgrey",
        padding: "20px",
        borderRadius: "15px",
      }}
      textAlign="center"
    >
      <Typography variant="p" gutterBottom>
        Average Watch Time
      </Typography>

      <BarChart
        width={500}
        height={300}
        data={data}
        layout="vertical"
        margin={{ top: 20, right: 30, left: 20, bottom: 20 }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis
          type="number"
          label={{ value: "Minutes", position: "insideBottom", offset: -10 }}
        />
        <YAxis type="category" dataKey="name" style={{ fontSize: "12px" }} />
        <Tooltip content={<CustomTooltip />} />
        {/* <Legend /> */}
        <Bar
          label="Average Watch Time"
          dataKey="avgWatchTime"
          fill="#82ca9d"
          barSize={20}
        />
      </BarChart>
    </Box>
  );
};

export default AverageWatchTimeChart;
